module.exports = __webpack_public_path__ + "img/image_part_001.0f0ca9d1.jpg";